<template>
    <layout name="LayoutDefault">
        <div class="About">
            <!-- Page Content -->
            <div class="container">
                <!-- Page Features -->
                <div class="contents">
                    <div class="row">
                        <div class="col-lg-12 col-sm-12">
                            <div class="blog-post">
                                <h2 class="blog-title">
                                    <a href="#">{{dataRow[0].title}}</a>
                                </h2>
                                <div class="details">
                                    <span class="date">{{dataRow[0].created_at}}</span>
                                </div>

                                <div class="blog-content mt-3 text-justify">
                                    <vue-load-image>
                                        <img slot="image" v-bind:src="`${IMAGEURL}${dataRow[0].image}`" alt="" class="img-responsive blog-image"/>
                                        <img slot="preloader" v-bind:src="`${baseUrl}/assets/img/loader.gif`" title="Image Loading..."/>
                                        <div slot="error">can't load image</div>
                                    </vue-load-image>
                                    <div v-html="`${dataRow[0].description}`"></div>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.container -->
        </div>
    </layout>
</template>

<script>
    import Layout from '../layouts/Layout';
    import VueLoadImage from 'vue-load-image';

    export default {
        data() {
            return {
                dataRow: [
                    {
                        'image': 'Loading...',
                        'description': 'Loading...',
                        'title': 'Loading...'
                    }
                ],
            }
        },
        components: {
            Layout,
            VueLoadImage
        },
        methods: {
            getData() {
                fetch(this.APIURL + 'cms-resources/Press/' + this.$route.params.id)
                    .then(response => response.json())
                    .then(json => this.dataRow = json.data)
            }
        },
        mounted() {
            this.getData();
        }
    };
</script>
